import { ACCESS_TOKEN, AUTH_TYPE, USER_DATA, USER_ID } from './constants';

// Token management
export const setAuthToken = (token: string): void => {
  localStorage.setItem(ACCESS_TOKEN, token);
};

export const getAuthToken = (): string | null => {
  return localStorage.getItem(ACCESS_TOKEN);
};

export const removeAuthToken = (): void => {
  localStorage.removeItem(ACCESS_TOKEN);
};

// Auth type management
export const setAuthType = (authType: string): void => {
  localStorage.setItem(AUTH_TYPE, authType);
};

export const getAuthType = (): string | null => {
  return localStorage.getItem(AUTH_TYPE);
};

export const removeAuthType = (): void => {
  localStorage.removeItem(AUTH_TYPE);
};

// User data management
export const setUserData = (userData: any): void => {
  localStorage.setItem(USER_DATA, JSON.stringify(userData));
};

export const getUserData = (): any | null => {
  const data = localStorage.getItem(USER_DATA);
  return data ? JSON.parse(data) : null;
};

export const removeUserData = (): void => {
  localStorage.removeItem(USER_DATA);
};

// User ID management
export const setUserId = (userId: string): void => {
  localStorage.setItem(USER_ID, userId);
};

export const getUserId = (): string | null => {
  return localStorage.getItem(USER_ID);
};

export const removeUserId = (): void => {
  localStorage.removeItem(USER_ID);
};

// Clear all auth data
export const clearAuthData = (): void => {
  removeAuthToken();
  removeAuthType();
  removeUserData();
  removeUserId();
};
